import {
  WRAPPER_ELEMENT,
  document_contains_attrs,
  BUILD_ASSET_URI,
  BANNER_ELEMENT_CONFIG
} from './src/utils.js'

!((doc, cohesion) => {
  if (Object.prototype.toString.call(cohesion) !== '[object Function]') {
    return false
  }

  cohesion('ready', function() {
    /** Only load the meat of StickyBanner if the data attributes are present on the page */
    if (document_contains_attrs()) {
      let sickyBannerStyles = doc.createElement('link')
      sickyBannerStyles.setAttribute('rel', 'stylesheet')
      sickyBannerStyles.setAttribute(
        'href',
        BUILD_ASSET_URI('css/brcom/sticky-banner.css')
      )

      let sickyBannerScript = doc.createElement('script')
      sickyBannerScript.setAttribute('defer', 'defer')
      sickyBannerScript.setAttribute(
        'src',
        BUILD_ASSET_URI('js/sticky-banner-src.js')
      )
      doc.head.appendChild(sickyBannerScript)
      doc.head.appendChild(sickyBannerStyles)

      sickyBannerScript.onload = function() {
        let options = BANNER_ELEMENT_CONFIG.io_config.options
        if (!window.StickyBanners) return

        const StickyBanners = window.StickyBanners
        const stickyBanners = new StickyBanners(WRAPPER_ELEMENT, options)

        stickyBanners.init()
      }
    }
  })
})(document, window.cohesion)
